import { Box } from '@mui/material';

import { useAppSelector } from '../app/store/hooks';
import LoginWithPhone from '../components/authentication/LoginWithPhone';
import LoadingUpAnimation from '../components/LoadingUpAnimation';

const SignIn = () => {
  const isAuthLoading = useAppSelector((state) => state.auth.isAuthLoading)

  if (isAuthLoading) {
    return <LoadingUpAnimation />
  }

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        height: "100vh",
        alignItems: "center",
        backgroundColor: '#FCF8EA',
      }}
    >
      <LoginWithPhone />
    </Box>
  );
}

export default SignIn